import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Isvg from 'react-inlinesvg';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import { memberStatus as memberStatusEnum } from 'enums/memberStatus';
import { memberStatus as memberStatusSelector } from 'redux/saga/selectors/user';
import { decorateWith, withName } from 'helpers/decorator';
export var mapStateToProps = function mapStateToProps(state) {
  return {
    isActive: memberStatusEnum('ACTIVE', memberStatusSelector(state))
  };
};
export var GiftLinkUnwrapped = function GiftLinkUnwrapped(_ref) {
  var isActive = _ref.isActive;
  return React.createElement("li", {
    className: classNames('header__gifts', {
      'header__gifts--attention': isActive
    })
  }, React.createElement(Link, {
    to: "/gifts?ref=header_click"
  }, React.createElement(FormattedMessage, {
    id: "header.link.gifts",
    defaultMessage: "Gifts"
  }), isActive && React.createElement(Isvg, {
    key: "gift-green",
    className: "svg",
    src: require('../../../../static/img/icon/gift-green.svg')
  })));
};
GiftLinkUnwrapped.propTypes = {
  isActive: PropTypes.bool.isRequired
};
export var GiftLink = decorateWith(connect(mapStateToProps), withName('GiftLink'))(GiftLinkUnwrapped);